import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import doctorDashboard from "./doctorDashboard.service";
import { Notification } from "../../../components/GenericActions";

const initialState = {
  doctorAppointmentCount: null,
  isLoggedIn: false,
  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const getDoctorAptCount = createAsyncThunk(
  "doctorDashboard/getDoctorAppointmentCount",
  async (thunkAPI) => {
    try {
      return await doctorDashboard.getDoctorAppointmentCount();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      Notification(message, false);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const doctorDashboardSlice = createSlice({
  name: "doctorDashboard",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDoctorAptCount.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDoctorAptCount.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.doctorAppointmentCount = action.payload.data;
      })
      .addCase(getDoctorAptCount.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      });
  },
});
export const { clearData } = doctorDashboardSlice.actions;

export default doctorDashboardSlice.reducer;
